<script setup lang="ts">
const accountStore = useAccountStore();

const { t } = useI18n({
  useScope: 'local',
});

const hasUrls = computed(() => accountStore.activeHousingExports.length > 0);
</script>

<template>
  <h1>{{ t('title') }}</h1>
  <p>{{ hasUrls ? t('text-has-urls') : t('text-has-no-urls') }}</p>
  <ul v-if="accountStore.activeHousingExports.length > 0">
    <li v-for="item in accountStore.activeHousingExports" :key="item.platform">
      {{ t(item.platform) }}: <tw-ui-action v-if="item.url" is="link" variant="text-primary" :to="item.url" target="_blank">{{ item.url }}</tw-ui-action
      ><span v-else>{{ t('is-being-exported') }}</span>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
@import '@/assets/styles/tw-mixins.scss';

h1 {
  margin: 0;
  line-height: 1.2;
  font-size: 1.6rem;
  font-weight: bold;
  text-align: center;

  @include tw-is-desktop {
    margin: 0 1rem 2rem;
    font-size: 2.25rem;
  }
}

p,
ul {
  text-align: center;
  margin-bottom: 2rem;
}

li {
  word-break: break-all;
}
</style>

<i18n lang="json">
{
  "de": {
    "title": "Deine Anzeige auf unseren Partnerplattformen",
    "text-has-urls": "Du findest deine Anzeige bei unseren Partnern unter den folgenden Links:",
    "text-has-no-urls": "Es kann bis zu 6 Stunden dauern, bis die Anzeige veröffentlicht wurde.",
    "is-being-exported": "Wird exportiert...",
    "immoscout24.de": "Immoscout24",
    "immobilo": "Immobilo",
    "immowelt": "Immowelt",
    "ebay-kleinanzeigen": "Kleinanzeigen"
  },
  "en": {
    "title": "Your ad on our partner platforms",
    "text-has-urls": "You can find your ad with our partners under the following links:",
    "text-has-no-urls": "It can take up to 6 hours for the ad to be published.",
    "is-being-exported": "Is being exported...",
    "immoscout24.de": "Immoscout24",
    "immobilo": "Immobilo",
    "immowelt": "Immowelt",
    "ebay-kleinanzeigen": "Kleinanzeigen"
  }
}
</i18n>
